import {
  createMediator,
  type Mediator,
  type TypedEvent,
} from "@/shared/lib/componentHierarchy";

export type InlinePlaybackEvent = {
  type: "media.inline.play" | "media.inline.release";
  id: string;
};
export type InlinePlaybackMediator = Mediator<
  string | null,
  InlinePlaybackEvent,
  never
>;

export function isInlinePlaybackEvent(
  event: TypedEvent,
): event is InlinePlaybackEvent {
  return (
    event.type === "media.inline.play" || event.type === "media.inline.release"
  );
}

export function createInlinePlaybackMediator(): InlinePlaybackMediator {
  return createMediator<string | null, InlinePlaybackEvent>(
    null,
    (state, event) => ({
      status: "handled",
      state:
        event.type === "media.inline.play"
          ? event.id
          : state === event.id
            ? null
            : state,
    }),
  );
}
